module.exports = __webpack_public_path__ + "img/people.5a81a205.png";